import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosClient from "../api/axiosClient"; // adjust path as needed
import { logoutUser } from "../api/tokenUtils";
import "../Shifts.css";

function AllShifts() {
  const [shifts, setShifts] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logoutUser(); // Clear tokens
    navigate("/");  // Redirect to the login page
  };

  useEffect(() => {
    axiosClient
      .get("/shifts/all/")
      .then(({ data }) => {
        setShifts(data);
      })
      .catch(err => {
        console.error("Failed to load shifts:", err);
        setError(err.message || "Failed to load shifts");
      });
  }, []);

  return (
    <>
      <header className="app-header" style={{ borderBottom: "none", boxShadow: "none" }}>
        <img src="/new_logo.png" alt="Logo" className="logo-shifts" />
        
        <nav className="header-nav">
          <button onClick={() => navigate("/dashboard")} className="home-button">
            Home
          </button>
          <button onClick={handleLogout} className="logout-shifts-button">
            Logout
          </button>
        </nav>
      </header>

      <div className="page-container-shifts">
        <h1 className="title-shifts">Shifts History</h1>
        {error && <div className="error">{error}</div>}

        <table className="shifts-table">
          <thead>
            <tr>
              <th>Clock In</th>
              <th>Clock Out</th>
              <th>Location</th>
            </tr>
          </thead>
          <tbody>
            {shifts.map(s => (
              <tr key={s.id}>
                <td>{`${new Date(s.clock_in)
                    .toLocaleDateString(undefined, { month: "short", day: "numeric" })}
                    ${new Date(s.clock_in)
                    .toLocaleTimeString(undefined, {
                      hour: "numeric",
                      minute: "2-digit",
                      hour12: true,
                    })
                    .replace(/\s+/g, "")}`.trim()}
                </td>
                <td>
                {s.clock_out
                  ? `${new Date(s.clock_out).toLocaleDateString(undefined, {month:"short", day:"numeric"})} ${new Date(s.clock_out).toLocaleTimeString(undefined,{hour:"numeric",minute:"2-digit",hour12:true}).replace(/\s+/g,"")}`
                  : "—"}
                </td>
                <td>
                  {s.address_clock_in
                    ? s.address_clock_in
                    : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default AllShifts;
